export default "__VITE_ASSET__CLX4Ttx3__"